import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
const API_URL = environment.apiUrl + '/promoRoutes';
@Injectable()
export class PromoService {
  constructor(private http: HttpClient) { }
  getContent() {
    return this
      .http
      .get(API_URL).pipe(
        map(res => {
          return res;
        }));
  }
add(promo: any) {
  const uri = API_URL + '/add';

  if (promo.code) {
    promo.code = promo.code.trim().toUpperCase();
  }

  return this.http.post(uri, promo);
}



 delete(id: string) {
  const uri = API_URL + '/delete/' + id;
  return this.http.get(uri).pipe(map(res => res));
}


  edit(id) {
    const uri = API_URL + '/edit/' + id;
    return this
      .http
      .get(uri).pipe(
        map(res => {
          return res;
        }));
  }
  editadminpromo(id) {
    const uri = API_URL + '/editpromo/' + id;
    return this
      .http
      .get(uri).pipe(
        map(res => {
          return res;
        }));
  }
  update(page: any, id: string) {
  const uri = API_URL + '/update/' + id;
  // send the whole object, not just title/content
  return this.http.post(uri, page).pipe(
    map(res => res)
  );
}

  getCount() {
    const uri = API_URL + '/promoCount';
    return this
      .http
      .get(uri).pipe(
        map(res => res));
  }

 getFirstridePromos() {
  return this.http.get(API_URL + '/firstride');
}

getCommonCampaigns() {
  return this.http.get(API_URL + '/commoncampaign');
}

getFirstrideHistory() {
  return this.http.get(API_URL + '/firstride/history');
}

getCommonCampaignHistory() {
  return this.http.get(API_URL + '/commoncampaign/history');
}


}
